var _defs, _circle, _path, _path2, _path3, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "carrier",
    x1: 10,
    x2: 54,
    y1: 20,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A78BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AED"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6D28D9",
    d: "M25 13h14c4 0 7 3 7 7v5h-6v-4c0-2-1-3-3-3H27c-2 0-3 1-3 3v4h-6v-5c0-4 3-7 7-7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#carrier)",
    d: "M10 25h44l4 27H6l4-27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4B5FD",
    d: "M17 32h30v15H17z",
    rx: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C1D95",
    d: "M22 35h4v9h-4zM30 35h4v9h-4zM38 35h4v9h-4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 52,
    r: 4,
    fill: "#4C1D95"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 52,
    r: 4,
    fill: "#4C1D95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrier);
export default __webpack_public_path__ + "static/media/carrier.d513863c8b7a7ca1605bf58502d00ebb.svg";
export { ForwardRef as ReactComponent };